import React from "react";

export default function SQLServer_SYSTEM_USER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SYSTEM_USER</h1>
      <p>This is the SQLServer_SYSTEM_USER component generated from the SQL JSON.</p>
    </div>
  );
}
